import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowRef {
  get href(): string {
    return window.location.href;
  }

  set href(value: string) {
    window.location.href = value;
  }

  get search(): string {
    return window.location.search;
  }

  reload(): void {
    window.location.reload();
  }
}
